// extracted by mini-css-extract-plugin
export default {"summaryContent":"FaqAccordion_summaryContent__v4vI9","detailContent":"FaqAccordion_detailContent__mwCWO"};